<script setup>
  import { computed } from 'vue';
  import { useProForecastStore } from '@/stores/ProForecastStore';
  import { isToday, isTomorrow, isYesterday, isPast } from 'date-fns';
  import ProForecastSpotForecast from '@/components/ProForecastSpotForecast.vue';

  const props = defineProps({
    spotForecasts: {
      type: Array,
      required: true
    },
    validDate: {
      type: String,
      required: true
    },
    isSample: {
      type: Boolean,
      default: false
    }
  });

  const proForecastStore = useProForecastStore();
  const getSpotForecastState = (spotId) => proForecastStore.spotForecastState ? proForecastStore.spotForecastState[spotId] : null;

  const blockDateHeader = computed(() => {
    if (props.isSample) return "Today's Forecast";

    const date = new Date(props.validDate);

    if (isToday(date)) {
      return "Today's Spot Forecasts";
    } else if (isTomorrow(date)) {
      return "Tomorrow's Spot Forecasts";
    } else if (isYesterday(date)) {
      return "Yesterdays's Spot Forecasts";
    } else if (isPast(date)) {
      return "Previous Spot Forecasts";
    } else {
      return "Upcoming Spot Forecasts";
    }
  });
  
  const handleAccordianToggle = (e) => {
    if (props.isSample) return;
    
    const { collapsed, spotId } = e;

    const spotState = {
      ...proForecastStore.spotForecastState,
      [spotId]: {
        ...proForecastStore.spotForecastState[spotId],
        collapsed: collapsed
      }
    }

    proForecastStore.spotForecastState = spotState;
  }
</script>

<template>
  <section class="jwx-page__section" data-divider="true">
    <div class="jwx-page__section-header">
      <h2 class="jwx-page__section-title">{{ blockDateHeader }}</h2>
      <p class="jwx-page__section__header-info jwx-font-size-sm jwx-text-color-subtle jwx-font-weight-400">Wind speed: kts</p>
    </div>
    <ProForecastSpotForecast
      v-for="spotForecast in props.spotForecasts"
      @accordian:toggle="handleAccordianToggle($event)"
      :spotForecast="spotForecast"
      :spotForecastState="getSpotForecastState(spotForecast.spot_id)"
      :key="spotForecast.spot_id"
    >
    </ProForecastSpotForecast>
  </section>
</template>